import React from 'react'
import { Switch, Route } from "react-router-dom";
import PublicViews from 'views/public-views'

export const PublicLayout = () => {
	return (
		<div className="public-container">
			<Switch>
				<Route path="" component={PublicViews} />
			</Switch>
		</div>
	)
}

export default PublicLayout
